// extracted by mini-css-extract-plugin
module.exports = {"m11idq95":"m11idq95","iwykk9x":"iwykk9x","m1gpa5eh":"m1gpa5eh","bb8e2zz":"bb8e2zz","u1r68xxg":"u1r68xxg"};